import React from "react";
import { useTranslation } from "react-i18next";
import { useFormat } from "../../../../i18n/format";
import { LEGAL_PATHS } from "../../../Auth/Legal/legalRules";
import "./ProfileModal.css";
import RiseModal from "../../../RiseModal/RiseModal";
import CircularProgress from "@mui/material/CircularProgress";
import { useSelector } from "react-redux";
import { IoLogOutOutline } from "react-icons/io5";
import { BsShieldLockFill } from "react-icons/bs";
import { BiSolidNotepad } from "react-icons/bi";
import { useLogout } from "../../../../hooks/useLogout";

const OneTimeShipperProfileModal = ({ onClose, style }) => {
  const user = useSelector((state) => state.user);
  const { t, i18n } = useTranslation(["nav", "common"]);
  const { formatMoney } = useFormat();
  const lang = i18n.resolvedLanguage === "fr" ? "fr" : "en";
  const { logout: handleLogout, loggingOut } = useLogout();

  return (
    <RiseModal style={style} onClose={onClose}>
      <div className="profile_modal">
        <div className="profile_modal_title">
          {t("nav:balance", { amount: formatMoney(user.balance) })}
        </div>
        <a
          className="profile_modal_item"
          href={LEGAL_PATHS.privacy[lang]}
          target="_blank"
          rel="noreferrer"
        >
          <BsShieldLockFill size={20} className="profile_modal_icon" />
          <div>{t("nav:privacyPolicy")}</div>
        </a>
        <a
          className="profile_modal_item"
          href={LEGAL_PATHS.terms[lang]}
          target="_blank"
          rel="noreferrer"
        >
          <BiSolidNotepad size={20} className="profile_modal_icon" />
          <div>{t("nav:terms")}</div>
        </a>

        <hr />
        <div
          className={`profile_modal_item ${
            loggingOut && "profile_modal_itemdisabled"
          }`}
          onClick={handleLogout}
        >
          <IoLogOutOutline size={20} className="profile_modal_icon" />
          <div>{t("common:actions.logout")}</div>
          {!loggingOut && (
            <div className="version__badge">
              {process.env.React_APP_Version}
              <span></span>
            </div>
          )}
          <span className="pm_item_logoutloader">
            {" "}
            {loggingOut && <CircularProgress size={16} />}
          </span>
        </div>
      </div>
    </RiseModal>
  );
};

export default OneTimeShipperProfileModal;
